// *******************************************************************************
// Product Slider
// *******************************************************************************

const productContentSlider = document.querySelectorAll('[data-slider="product-slider-content"]');

if (productContentSlider.length > 0) {
  // Content Slider
  const productContentSliderOptions = {
    slidesPerView: 1,
    spaceBetween: 16,
    speed: 300,
    effect: 'fade',
    fadeEffect: {
      crossFade: false,
    },
    loop: false,
    allowTouchMove: false,
  };

  productContentSlider.forEach((el) => new Swiper(el, productContentSliderOptions));

  document.addEventListener('DOMContentLoaded', () => {
    const contentSliders = Array.from(productContentSlider).map((el) => el.swiper);

    // Product Slider
    const productSliderModule = document.querySelectorAll('.product-slider');

    productSliderModule.forEach((ele) => {
      const imageSlider = ele.querySelector('.product-slider__image-slider');
      const slides = gsap.utils.toArray('.product-slider__image');
      const slice = 360 / slides.length;
      const bgTitleList = ele.querySelector('.product-slider__title-slider-inner');
      const bgTitles = bgTitleList.querySelectorAll('.product-slider__bg-title');
      let singleTitleHeight = bgTitles[0].offsetHeight;
      // eslint-disable-next-line no-unused-vars
      let isRotating = false;
      let activeBgTitle = 0;
      let activeIndex = 0;

      const sliderSetup = () => {
        const radius = imageSlider.offsetWidth / 2;
        const center = radius;
        const DEG2RAD = Math.PI / 180;
        gsap.set(slides, {
          x: (i) => center + radius * Math.sin(i * slice * DEG2RAD),
          y: (i) => center - radius * Math.cos(i * slice * DEG2RAD),
          rotation: (i) => i * slice,
          xPercent: -50,
          yPercent: -50,
        });
      };

      sliderSetup();

      window.addEventListener('resize', () => {
        sliderSetup();
        syncActiveIndex();
        if (windowWidth() >= breakpointSm) {
          updateThumbSliderBounds();
        }
        singleTitleHeight = bgTitles[0].offsetHeight;
      });

      const centerWheel = (newRotation) => {
        gsap.to(imageSlider, {
          duration: 1.5,
          ease: 'elastic.out(1,0.75)',
          rotation: newRotation,
        });
      };

      const sliderEffect = (rotationChange, direction) => {
        if (direction === 'next') {
          activeBgTitle = (activeBgTitle + 1) % bgTitles.length;
        } else if (direction === 'prev') {
          activeBgTitle = (activeBgTitle - 1 + bgTitles.length) % bgTitles.length;
        }

        bgTitleSlideTo(activeBgTitle);

        // Ensure imageSlider exists before modifying it
        if (!imageSlider) return;

        // Get current rotation value
        const currentRotation = parseFloat(imageSlider.getAttribute('data-rotate')) || 0;
        const newRotation = currentRotation + parseFloat(rotationChange);

        // Use GSAP to animate rotation
        gsap.to(imageSlider, {
          duration: 1.5,
          ease: 'elastic.out(1, 0.75)',
          rotation: `+=${parseFloat(rotationChange)}`,
          onUpdate: () => {
            imageSlider.setAttribute('data-rotate', newRotation);
            updateSlideClasses();
          },
          onComplete: () => {
            isRotating = false;
          },
          onStart: () => {
            centerWheel(newRotation);
          },
        });
      };

      let lastRotateTime = 0;
      const rotateWheel = (direction) => {
        const now = Date.now();
        if (now - lastRotateTime < 300) return; // 300ms cooldown
        lastRotateTime = now;

        // gsap.killTweensOf(imageSlider);

        if (direction === 'next') {
          activeIndex = (activeIndex + 1) % slides.length;
        } else if (direction === 'prev') {
          activeIndex = (activeIndex - 1 + slides.length) % slides.length;
        }

        const rotationChange = direction === 'next' ? -slice : slice;
        syncActiveIndex();
        sliderEffect(rotationChange, direction);
      };

      // Background Title Slider
      const bgTitleSlideTo = (index) => {
        gsap.to(bgTitleList, {
          y: -index * singleTitleHeight,
          duration: 1.5,
          ease: 'elastic.out(1, 0.75)',
        });
      };

      const updateSlideClasses = () => {
        setTimeout(() => {
          const currentRotation = gsap.getProperty(imageSlider, 'rotation') % 360;
          let activeIndex = Math.round(-currentRotation / slice) % slides.length;

          if (activeIndex < 0) {
            activeIndex += slides.length;
          }

          slides.forEach((slide, i) => {
            slide.classList.remove('is-prev', 'is-active', 'is-next');

            if (i === activeIndex) {
              slide.classList.add('is-active');
              contentSliders.forEach((slider) => slider.slideTo(activeIndex, 300));
            } else if (i === (activeIndex - 1 + slides.length) % slides.length) {
              slide.classList.add('is-prev');
            } else if (i === (activeIndex + 1) % slides.length) {
              slide.classList.add('is-next');
            }
          });
        }, 100);
      };

      updateSlideClasses();

      // Drag
      const innerWrapper = ele.querySelector('.product-slider__inner');
      let startX = 0;
      let isDragging = false;

      const startDrag = (e) => {
        e.preventDefault();
        isDragging = true;
        startX = e.type.includes('touch') ? e.touches[0].clientX : e.clientX;

        // gsap.killTweensOf(imageSlider);

        document.addEventListener('mousemove', dragMove);
        document.addEventListener('touchmove', dragMove);
        document.addEventListener('mouseup', endDrag);
        document.addEventListener('touchend', endDrag);
      };

      const dragMove = (e) => {
        if (!isDragging) return;

        const moveX = e.type.includes('touch') ? e.touches[0].clientX : e.clientX;
        const deltaX = moveX - startX;

        const threshold = e.type.includes('touch') ? 30 : 8; // Higher threshold for touch

        if (Math.abs(deltaX) > threshold) {
          rotateWheel(deltaX > 0 ? 'prev' : 'next');
          startX = moveX;
        }
      };

      const endDrag = () => {
        if (!isDragging) return;
        isDragging = false;
        isRotating = false;

        document.removeEventListener('mousemove', dragMove);
        document.removeEventListener('touchmove', dragMove);
        document.removeEventListener('mouseup', endDrag);
        document.removeEventListener('touchend', endDrag);
      };

      innerWrapper.addEventListener('mousedown', startDrag);
      innerWrapper.addEventListener('touchstart', startDrag);

      const prevButton = ele.querySelector('.swiper-button-prev');
      const nextButton = ele.querySelector('.swiper-button-next');
      prevButton?.addEventListener('click', () => rotateWheel('prev'));
      nextButton?.addEventListener('click', () => rotateWheel('next'));

      // Thumb Handle

      const thumbSlider = ele.querySelector('.product-slider__thumb-slider');
      const thumbSliderWrapper = ele.querySelector('.product-slider__thumb-slider-wrapper');

      let draggableInstance;
      let velocity = 0;

      const moveThumbSlider = () => {
        const thumbSlide = thumbSlider.querySelector('.product-slider__thumb');
        const itemWidth = thumbSlide ? thumbSlide.offsetWidth + (windowWidth() >= breakpointSm ? '30' : '4') : 120;

        const minX = -(thumbSlider.scrollWidth - thumbSliderWrapper.offsetWidth);
        const maxX = 0;
        let newThumbX = -activeIndex * itemWidth;

        if (newThumbX < minX) newThumbX = minX;
        if (newThumbX > maxX) newThumbX = maxX;

        if (windowWidth() >= breakpointSm) {
          gsap.to(thumbSlider, { x: newThumbX, duration: 0.6, ease: 'power3.out', zIndex: 1 });
        }
      };

      const moveThumbCenter = () => {
        if (windowWidth() > breakpointSm) return;

        const thumbSlides = Array.from(thumbSlider.querySelectorAll('.product-slider__thumb'));
        const activeThumb = thumbSlides[activeIndex];
        if (!activeThumb) return;

        const thumbSliderWrapperWidth = thumbSliderWrapper.clientWidth;
        const activeThumbWidth = activeThumb.offsetWidth;
        const activeThumbOffset = activeThumb.offsetLeft + activeThumbWidth / 2;

        const newScrollLeft = activeThumbOffset - thumbSliderWrapperWidth / 2;

        thumbSlider.scrollTo({
          left: newScrollLeft,
          behavior: 'smooth',
        });
      };

      const updateActiveThumb = () => {
        const allThumbSlides = Array.from(thumbSlider.querySelectorAll('.product-slider__thumb'));

        allThumbSlides.forEach((thumb, index) => {
          thumb.classList.toggle('is-active', index === activeIndex);
        });
      };

      const updateThumbSliderBounds = () => {
        const minX = -(thumbSlider.scrollWidth - thumbSliderWrapper.offsetWidth);
        const maxX = 0;
        const overshoot = 100;

        if (thumbSlider.scrollWidth > thumbSliderWrapper.offsetWidth) {
          if (!draggableInstance) {
            draggableInstance = Draggable.create(thumbSlider, {
              type: 'x',
              edgeResistance: 0.8,
              bounds: { minX: minX - overshoot, maxX: maxX + overshoot },
              onDragStart() {
                this.initialX = this.x;
                velocity = 0;
                gsap.set(thumbSlider, { zIndex: 1 });
              },
              onDrag() {
                velocity = this.x - this.initialX;
                gsap.set(thumbSlider, { zIndex: 1 });
              },
              onDragEnd() {
                const finalX = this.x + velocity * 0.8;
                gsap.set(thumbSlider, { zIndex: 1 });

                if (finalX < minX) {
                  gsap.to(thumbSlider, { x: minX, duration: 1.2, ease: 'elastic.out(1, 1)' });
                } else if (finalX > maxX) {
                  gsap.to(thumbSlider, { x: maxX, duration: 1.2, ease: 'elastic.out(1, 1)' });
                } else {
                  gsap.to(thumbSlider, { x: finalX, duration: 1, ease: 'power3.out' });
                }
              },
            });
          } else {
            draggableInstance[0].applyBounds({ minX: minX - overshoot, maxX: maxX + overshoot });
          }
        } else {
          gsap.set(thumbSlider, { x: 0 });
          if (draggableInstance) {
            draggableInstance[0].kill();
            draggableInstance = null;
          }
        }
      };

      const syncActiveIndex = () => {
        updateActiveThumb();
        moveThumbSlider();
        moveThumbCenter();
      };

      syncActiveIndex();
      if (windowWidth() >= breakpointSm) {
        updateThumbSliderBounds();
      }

      // Flag to track swipe
      let isSwiping = false;
      let touchStartX = 0;
      let touchStartY = 0;
      const SWIPE_THRESHOLD = 10;

      attachEvent('.product-slider__thumb', 'touchstart', (e) => {
        const [touch] = e.touches;
        touchStartX = touch.clientX;
        touchStartY = touch.clientY;
        isSwiping = false;
      });

      attachEvent('.product-slider__thumb', 'touchmove', (e) => {
        const [touch] = e.touches;
        const diffX = Math.abs(touch.clientX - touchStartX);
        const diffY = Math.abs(touch.clientY - touchStartY);

        if (diffX > SWIPE_THRESHOLD || diffY > SWIPE_THRESHOLD) {
          isSwiping = true;
        }
      });

      const handleThumbInteraction = (ele, i) => {
        const thumbSliderEle = ele.closest('.product-slider__thumb-slider');

        if (!thumbSliderEle) {
          return;
        }

        const allThumbSlides = Array.from(thumbSliderEle.querySelectorAll('.product-slider__thumb'));
        const eleIndex = allThumbSlides.indexOf(ele.closest('.product-slider__thumb'));
        const lastIndex = allThumbSlides.indexOf(thumbSliderEle.querySelector('.is-active'));
        allThumbSlides.forEach((slide) => slide.classList.remove('is-active'));

        activeIndex = eleIndex;
        if (eleIndex !== -1) {
          allThumbSlides[eleIndex].classList.add('is-active');
        }

        const finalIndex = lastIndex - i;
        sliderEffect(finalIndex * slice, finalIndex > 0 ? 'next' : 'prev');

        activeBgTitle = eleIndex;
        bgTitleSlideTo(activeBgTitle);

        if (windowWidth() <= breakpointSm) {
          updateActiveThumb();
          moveThumbSlider();
        }
      };

      const thumbSlides = document.querySelectorAll('.product-slider__thumb');
      thumbSlides.forEach((thumb, i) => {
        thumb.addEventListener('click', () => {
          handleThumbInteraction(thumb, i);

          if (windowWidth() <= breakpointSm) {
            if (isSwiping) {
              updateActiveThumb();
              moveThumbSlider();
            }
          }
        });

        thumb.addEventListener('touchend', () => {
          if (isSwiping) {
            isSwiping = false;
            return;
          }
          handleThumbInteraction(ele);
        });
      });

      const checkThumbVisibility = () => {
        const activeThumb = thumbSlider.querySelector('.product-slider__thumb.is-active');
        const thumbSliderRect = thumbSlider.getBoundingClientRect();
        const activeThumbRect = activeThumb.getBoundingClientRect();

        if (activeThumbRect.left < thumbSliderRect.left || activeThumbRect.right > thumbSliderRect.right) {
          moveThumbSlider();
        }
      };

      checkThumbVisibility();
    });

    // Press state for mobile
    const buttons = document.querySelectorAll('.product-slider .btn');
    if (windowWidth() < breakpointMd) {
      buttons.forEach((btn) => {
        btn.addEventListener('mousedown', () => {
          btn.classList.add('is-pressed');
        });

        btn.addEventListener('mouseup', () => {
          setTimeout(() => {
            btn.classList.remove('is-pressed');
          }, 200);
        });

        btn.addEventListener('touchstart', () => {
          btn.classList.add('is-pressed');
        });

        btn.addEventListener('touchend', () => {
          setTimeout(() => {
            btn.classList.remove('is-pressed');
          }, 200);
        });
      });
    }
  });
}
